import { AdContainer } from '@components/common/AdContainer/AdContainer';
import { AffiliateLink } from '@components/common/AffiliateLink';
import { CoinTicker } from '@components/common/CoinTicker';
import { SidebarWrapper } from '@components/common/SidebarWrapper/SidebarWrapper';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { FC, useMemo } from 'react';
import { ArticleLatestNews } from '../ArticleLatestNews/ArticleLatestNews';
import { ArticleTopReads } from '../ArticleTopReads/ArticleTopReads';
import { Container, StickyContainer } from './Sidebar.styles';
import { SidebarProps } from './Sidebar.types';

const AdPlacementComponent = dynamic(
  () => import('@components/common/AdPlacement').then((mod) => mod.AdPlacement),
  { ssr: false },
);

export const Sidebar: FC<SidebarProps> = ({
  ads,
  affiliateLinks,
  assets,
  affiliateLinksHeading,
  topReads,
  latestNews,
}) => {
  const { t } = useTranslation('articles');

  const headerAdHeight = useMemo(() => {
    return ads.find((ad) => ad.placement === 'classic-article-header-banner')?.heightPc || 0;
  }, [ads]);

  return (
    <Container marginTop={headerAdHeight}>
      {assets?.length > 0 && (
        <SidebarWrapper heading={t('coin-tickers')}>
          {assets.map((asset) => {
            return <CoinTicker key={asset.text} {...asset} />;
          })}
        </SidebarWrapper>
      )}
      <StickyContainer>
        {affiliateLinks?.length > 0 && (
          <SidebarWrapper heading={affiliateLinksHeading ?? t('affiliate-links')}>
            {affiliateLinks?.map((link) => (
              <AffiliateLink
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                image={link.logo.hash}
                href={link.url}
                text={link.text}
                title={link.name}
              />
            ))}
          </SidebarWrapper>
        )}
        <AdContainer adPlacements={ads} placement="article-side-banner" sponsoredText>
          <AdPlacementComponent adPlacements={ads} placement="article-side-banner" />
        </AdContainer>
        {latestNews?.length > 0 && (
          <ArticleLatestNews heading={t('latest-news')} articles={latestNews} />
        )}
        {topReads?.length > 0 && <ArticleTopReads heading={t('top-read')} articles={topReads} />}
      </StickyContainer>
    </Container>
  );
};
